import { IOption, IOptions } from '../common/common.types'
import { IHideableOptions } from '../features/options/store/options.types'

export const sort = (entity: IOptions): IOptions => {
  return entity && entity.sort((e1, e2) => (e2.name && e1.name?.localeCompare(e2.name)) || -1)
}

export const moveOptionToEnd = (entity: IOptions, id: number): IOptions => {
  if (entity) {
    const option = entity.splice(
      entity.findIndex((option) => option.id && option.id === id),
      1
    )
    if (option && option.length) {
      entity.push(option[0])
    }
  }
  return entity
}

export const sortAlphabeticallyByName = (entity: IOptions) =>
  entity.sort((a: IOption, b: IOption) => {
    if (!a.name || !b.name) {
      return 0
    }
    const nameA = a.name.toLowerCase()
    const nameB = b.name.toLowerCase()

    if (nameA < nameB) {
      return -1
    }
    if (nameA > nameB) {
      return 1
    }
    return 0
  })

export const filterHiddenOptions = (entity: IHideableOptions): IHideableOptions => {
  return entity.filter((option) => option?.hidden !== 1)
}
